module.exports = __webpack_public_path__ + "static/img/color.4eafa2cc.png";